import React from "react";

const JobSectionTitle = () => {
  return (
    <section className="tp-section-area pt-120">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="tp-section-wrapper-5 text-center mb-85">
              {/* <span className="tp-section-subtitle-5">Open Positions</span>
              <h3 className="tp-section-title-5">
                We’re looking for talented people
              </h3>
              <p>We’re 100% remote team spread all across the world.Join us!</p> */}

              <h3 className="tp-section-title-5">
                We've locked the door, but we hold the key for your entry into
                our future endeavors.
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JobSectionTitle;
